import { useState } from 'react';
import { Link, useLocation } from 'wouter';
import { Button } from '@/components/ui/button';
import { Menu, X } from 'lucide-react';
// Logo is served from public directory

export default function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const [location] = useLocation();

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/history', label: 'History' },
    { path: '/rules', label: 'Rules' },
    { path: '/weather', label: 'Weather' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <nav className="bg-gradient-navy shadow-lg sticky top-0 z-[9999]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link href="/">
            <div className="flex items-center space-x-3 cursor-pointer">
              <img 
                src="/vca-logo.svg" 
                alt="VCA Logo" 
                className="h-12 w-12 object-contain"
              />
              <div className="text-white">
                <div className="text-xl font-bold">Vaal Cruising Association</div>
                <div className="text-xs text-orange-300">Since 1968</div>
              </div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {navItems.map((item) => (
              <Link key={item.path} href={item.path}>
                <Button
                  variant={location === item.path ? "secondary" : "ghost"}
                  className={
                    location === item.path
                      ? "text-navy bg-orange-300 hover:bg-orange-400"
                      : "text-white hover:text-orange-300 hover:bg-white/10"
                  }
                >
                  {item.label}
                </Button>
              </Link>
            ))}
            
            {/* Member Login Button */}
            <a href="https://portal.vaalcruising.co.za/login">
              <Button className="ml-4 bg-orange-300 hover:bg-orange-400 text-navy font-semibold">
                Member Login
              </Button>
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setIsOpen(!isOpen)}
              className="text-white hover:text-orange-300 hover:bg-white/10"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </Button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden pb-4">
            <div className="flex flex-col space-y-2">
              {navItems.map((item) => (
                <Link key={item.path} href={item.path}>
                  <Button
                    variant={location === item.path ? "secondary" : "ghost"}
                    className={
                      location === item.path
                        ? "text-navy bg-orange-300 hover:bg-orange-400 w-full justify-start"
                        : "text-white hover:text-orange-300 hover:bg-white/10 w-full justify-start"
                    }
                    onClick={() => setIsOpen(false)}
                  >
                    {item.label}
                  </Button>
                </Link>
              ))}
              
              <a href="https://portal.vaalcruising.co.za/login">
                <Button className="mt-2 bg-orange-300 hover:bg-orange-400 text-navy font-semibold w-full">
                  Member Login
                </Button>
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}